<div class="favorite-icons">
  @if (userCanUseFavorites) {
    <icon-favorite [ngClass]="{'precious': $safeNavigationMigration(model?.PresentAsPrecious)}" [isFavorite]="isFavorite" (click)="toggleFavorite()"></icon-favorite>
  }
  @if (userCanUseFavorites) {
    <icon-my-collections [ngClass]="{'precious': $safeNavigationMigration(model?.PresentAsPrecious)}" class="ml-1" [isInCollection]="isInCollection" (click)="showMyCollections()"></icon-my-collections>
  }
</div>